import { render, staticRenderFns } from "./MaridajeHoney.vue?vue&type=template&id=688a0255&scoped=true&"
import script from "./MaridajeHoney.vue?vue&type=script&lang=js&"
export * from "./MaridajeHoney.vue?vue&type=script&lang=js&"
import style0 from "./MaridajeHoney.vue?vue&type=style&index=0&id=688a0255&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688a0255",
  null
  
)

export default component.exports